import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import TwoOptionsModal from './twoOptionsModal';
import addPlanRequest from '../../../../shared/api/addPlan/request';
import {
  modalSelector,
  setModal,
  setModalParams,
} from '../../../../shared/store/slices/modal.slice';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import Modals from '@shared/types/enums/modals';

function UpgradeRecordPlanModal() {
  const dispatch = useAppDispatch();
  const { params } = useAppSelector(modalSelector);

  const handleAccept = () => {
    addPlanRequest({
      functionality: 'diskAllocation',
      channelCode: (params as { channelCode?: string })?.channelCode,
    });
    dispatch(setModalParams({ accepted: true }));
    dispatch(setModal(Modals.UPGRADE_PLAN));
  };

  return (
    <TwoOptionsModal
      title={TranslationManager.get('MODAL.UPGRADE_RECORD_PLAN.TITLE')}
      acceptAction={handleAccept}
    />
  );
}

export default UpgradeRecordPlanModal;
